import PermissionGuard from 'components/Global/PermissionGuard'; // Make sure this path is correct
import HolidayComponent from 'components/Settings/Masters/Holidays';

export const Holiday = () => {
	return (
		<PermissionGuard permission="Allow_Holidays">
			<HolidayComponent />
		</PermissionGuard>
	);
};
